import React from 'react';
import { Row, Checkbox } from 'antd';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { BoxedNotification } from '../styled';

const rowStyle = { justifyContent: 'space-between', margin: '10px 0' };

const CheckboxGroup = ({ policy }) => (
  <BoxedNotification>
    <Row style={rowStyle}>
      <Checkbox checked={policy.setAsDefault} onChange={policy.toggleSetAsDefault}>
        <FormattedMessage id="listing.setDefaultPolicy" defaultMessage="Set policy as default" />
      </Checkbox>
    </Row>
    {/* <Row style={rowStyle}> */}
    {/* <Checkbox checked={policy.applyChangesToItems} onChange={policy.toggleApplyToItems}> */}
    {/* <FormattedMessage */}
    {/* id="listing.applyToAlreadyListed" */}
    {/* defaultMessage="Also apply changes to items already listed" */}
    {/* /> */}
    {/* </Checkbox> */}
    {/* </Row> */}
  </BoxedNotification>
);

CheckboxGroup.propTypes = {
  policy: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default observer(CheckboxGroup);
